import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context';
import { AppRouter } from './router';
import { OfflineIndicator, InstallPrompt } from './components/offline';
import { TourProvider } from './components/tour';
import { ToastContainer } from './components/common';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TourProvider>
          <AppRouter />
          <OfflineIndicator />
          <InstallPrompt />
          <ToastContainer />
        </TourProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
